import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

export interface I18nProviderProps {
  children: React.ReactNode;
}

/**
 * Envolve a árvore com o contexto do i18next.
 * Na Fase 1 o idioma é fixo (en-US); estrutura pronta para troca de idioma depois.
 */
export function I18nProvider({ children }: I18nProviderProps) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
